var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('icon',{attrs:{"icon":"arrows/arrow/arrow-curved-alt-left-circle"}}),_vm._v(" "),_c('span',[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }